import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'p-partial-list',
    template: `
        <div class="p-partial-list">
            <span>{{ visibleItemsLabel }}</span>
            <div *ngIf="hasHiddenValues" class="p-multiple-values-number">
                <span [matTooltip]="hiddenItemsLabel">
                    {{ '  + ' + hiddenItemsCount }}
                </span>
            </div>
        </div>
    `,
    styleUrls: ['p-partial-list-component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PPartialListComponent implements OnChanges {
    @Input() public valuesList: string[] | number[] | undefined = [];
    @Input() public numOfValuesToShow: number = 0;

    protected visibleItemsLabel: string = '';
    protected hasHiddenValues: boolean = false;
    protected hiddenItemsLabel: string = '';
    protected hiddenItemsCount: number = 0;

    ngOnChanges(): void {
        const valuesToShow = this.valuesList?.slice(0, this.numOfValuesToShow);
        const hiddenValues = this.valuesList?.slice(this.numOfValuesToShow);

        this.hiddenItemsCount = hiddenValues?.length ?? 0;
        this.hasHiddenValues = this.hiddenItemsCount > 0;
        this.visibleItemsLabel = valuesToShow?.join(', ') ?? '';
        this.hiddenItemsLabel = hiddenValues?.join(', ') ?? '';
    }
}
